/**
 * Глобальный обработчик ошибок
 * Показывает все ошибки на весь экран для удобного создания скриншотов
 */

let errorDisplayCallback = null;

/**
 * Устанавливает callback для отображения ошибок
 */
export function setErrorDisplayCallback(callback) {
  errorDisplayCallback = callback;
}

/**
 * Показывает ошибку на весь экран
 */
export function displayError(error, context = {}) {
  console.error('[ERROR HANDLER]', error, context);
  
  if (errorDisplayCallback) {
    errorDisplayCallback({
      message: error.message || String(error),
      stack: error.stack,
      name: error.name,
      status: error.status,
      data: error.data,
      context,
      timestamp: new Date().toISOString(),
    });
  }
}

/**
 * Инициализация глобальных обработчиков ошибок
 */
export function initGlobalErrorHandlers() {
  // Обработка необработанных ошибок
  window.addEventListener('error', (event) => {
    displayError(event.error || new Error(event.message), {
      type: 'window.error',
      filename: event.filename,
      lineno: event.lineno,
      colno: event.colno,
    });
  });

  // Обработка необработанных промисов
  window.addEventListener('unhandledrejection', (event) => {
    displayError(event.reason || new Error('Unhandled Promise Rejection'), {
      type: 'unhandledrejection',
      promise: String(event.promise),
    });
  });

  // Перехват console.error для отображения
  const originalConsoleError = console.error;
  console.error = function(...args) {
    originalConsoleError.apply(console, args);
    
    // Показываем на экране только реальные ошибки
    if (args.length > 0 && (args[0] instanceof Error || typeof args[0] === 'string')) {
      const error = args[0] instanceof Error ? args[0] : new Error(String(args[0]));
      displayError(error, {
        type: 'console.error',
        args: args.slice(1),
      });
    }
  };

  console.log('[ERROR HANDLER] Global error handlers initialized');
}
